import { Controller } from "@hotwired/stimulus"
import sortable from "html5sortable/dist/html5sortable.es"

// Connects to data-controller="column-order"
export default class extends Controller {
  static targets = ["list", "hiddenInputs"]
  static values = {
    category: String,
    device: String,
  }

  connect() {
    sortable(this.listTarget, {
      handle: ".drag-handle",
    })
    this.handleSortUpdate = () => this.updateHiddenInputs()
    this.listTarget.addEventListener("sortupdate", this.handleSortUpdate)
    this.updateHiddenInputs()
  }

  disconnect() {
    this.listTarget.removeEventListener("sortupdate", this.handleSortUpdate)
    sortable(this.listTarget, "destroy")
  }

  toggle() {
    this.updateHiddenInputs()
  }

  updateHiddenInputs() {
    const container = this.hiddenInputsTarget
    container.innerHTML = ""
    const fieldName = `user_setting[columns][${this.categoryValue}][${this.deviceValue}][]`

    this.listTarget.querySelectorAll("li[data-column]").forEach((item) => {
      const checkbox = item.querySelector('input[type="checkbox"]')
      const isLocked = item.hasAttribute("data-locked")

      if (isLocked || checkbox.checked) {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = fieldName
        input.value = item.dataset.column
        container.appendChild(input)
      }
    })
  }
}
